import { useDispatch, useSelector } from "react-redux";
import {
  selectSelectedActor,
  updateActor,
} from "../../app/slices/TrainingSlice";
import {
  ACTOR_AVATAR_PALETTE,
  getActorAvatarColorIndex,
  getActorAvatarColorByIndex,
} from "../../helpers/actorAvatar";

export default function ActorProfilePictureSelector() {
  const selectedActor = useSelector(selectSelectedActor);
  const dispatch = useDispatch();

  if (!selectedActor) return null;

  const selectedIndex = getActorAvatarColorIndex(selectedActor);

  const onColorClick = (index: number) => {
    dispatch(
      updateActor({
        ...selectedActor,
        profilePicture: index,
      })
    );
  };

  return (
    <div
      className="flex flex-wrap gap-[14px] py-[6px]"
      data-testid="actor-color-swatches"
    >
      {ACTOR_AVATAR_PALETTE.map((_, index) => {
        const isSelected = selectedIndex === index;
        return (
          <button
            type="button"
            key={index}
            aria-label={`color-${index}`}
            aria-pressed={isSelected}
            data-testid={`actor-color-${index}`}
            onClick={() => onColorClick(index)}
            className={
              "relative flex items-center justify-center w-[40px] h-[40px] rounded-circle cursor-pointer border-2 bg-transparent " +
              (isSelected
                ? "border-creator-primary shadow-base"
                : "border-creator-border")
            }
          >
            <span
              aria-hidden="true"
              className={
                "block w-[24px] h-[24px] rounded-circle " +
                getActorAvatarColorByIndex(index)
              }
            />
            {isSelected && (
              <div className="absolute bottom-[-10px] w-[28px] h-[3px] bg-creator-primary rounded-full" />
            )}
          </button>
        );
      })}
    </div>
  );
}
